module.exports = __webpack_public_path__ + "static/media/anc3ru.631fc474.pdf";